<template>
    <div class="intro">
      <div class="title">
        <p5-title content="Introduction" size="extra-large"></p5-title>
      </div>
      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">私の名は黄柏清。年齢23歳。</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">自宅は名古屋市中区にあり、結婚はしていない。</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">今は大囿研究室で、情报工学研究生になります。</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">毎日遅くとも夜8時までには帰宅する。</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">タバコは吸わない、酒はたしなむ程度。</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content_large">
            <p5-text size="large">寝る前に温かい牛乳を飲み、20分ほどのストレッチで体をほぐしてから床につくと、ほどんと朝まで熟睡さ。</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content_large">
            <p5-text size="large">赤ん坊のように疲労やストレスを残さずに、朝目を覚ませるんだ。健康診断でも異常なしと言われたよ。</p5-text>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Intro',
    data() {
        return {
            sl_value1: 100
        }
    },
    methods: {
        handleChange() {
        },
    }
  }
  </script>
  
<style>
.intro{
  margin: 220px 100px 0px 240px;
  height: calc(100% - 220px);
  width: 100%;
  overflow: auto;
}
.intro .p5-svg-party {
  width: 150px;
  height: 150px;
}
.intro .title{
  position: absolute;
  top: 115px;
  left: 750px;
  transform: rotate(8deg);
}
.intro .dialog{
  height: 200px;
  width: 1200px;
}
.intro .text-size-extra-large {
  display: block;
  font-size: 44px;
  text-align: center;
}
.intro .icon{
  float: left;
  margin: 0px -25px 0px 150px;
}
.intro .log{
  float: left;
  height: 158px;
  width: 700px;
  background: url("../assets/log.png") no-repeat;
  background-size: cover;
}
.intro .log .content{
  position: relative;
  top:60px;
  left: 135px;
}
.intro .log .content_large{
  position: relative;
  top: 48px;
  left: 135px;
  width: 450px;
}
  </style>
  